<template>
  <div
    ref="select"
    v-clickoutside="closePopup"
    class="search-filters-select"
  >
    <div
      v-if="!smallScreen"
      class="search-filters-select__desktop"
    >
      <div class="search-filters-select__title">
        {{ sortCtaDesktopLabel }}
        <button
          :aria-expanded="displayingPopup ? 'true' : 'false'"
          :class="['search-filters-select__title-filter', { 'search-filters-select__title-filter--active' : displayingPopup }]"
          @click="togglePopup()"
        >
          {{ selectedLabel }}
          <svg
            :class="['icon', { 'icon--opened' : displayingPopup }]"
            role="img"
          >
            <title class="is-sr-only">{{ displayingPopup ? sortExpandIconAlt : sortCollapseIconAlt }}</title>
            <use xlink:href="#chevron-right" />
          </svg>
        </button>
      </div>
    </div>

    <div
      v-if="smallScreen"
      class="search-filters-select__mobile"
      @click="togglePopup()"
    >
      <div class="search-filters-select__title">
        <span class="search-filters-select__title-filter">
          {{ sortCtaMobileLabel }}
          <svg
            :class="['icon', { 'icon--opened' : displayingPopup }]"
            role="img"
          >
            <title class="is-sr-only">{{ displayingPopup ? sortExpandIconAlt : sortCollapseIconAlt }}</title>
            <use xlink:href="#chevron-right" />
          </svg>
        </span>
      </div>
      <select
        id="options"
        v-model="selectedOption"
        name="options"
      >
        <option
          v-for="(option, i) in productsSorting.options"
          :key="i"
          :value="option.id"
        >
          {{ option.title }}
        </option>
      </select>
    </div>

    <div
      v-if="!smallScreen"
      v-show="displayingPopup"
      ref="popup"
      :aria-hidden="displayingPopup ? 'false' : 'true'"
      class="search-filters-select__popup search-filters-select__popup--sorting"
    >
      <label
        v-for="(option, i) in productsSorting.options"
        :key="i"
        :class="['search-filters-select__option', 'search-filters-select__option--sorting', { 'search-filters-select__option--disabled' : isLoadingFilters }]"
      >
        <input
          ref="switchCheckbox"
          v-model="selectedOption"
          :disabled="isLoadingFilters"
          name="search-filter-option"
          type="radio"
          :value="option.id"
        >
        <span class="checkmark" />
        {{ option.title }}
      </label>
    </div>
  </div>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  import { mapGetters, mapActions } from 'vuex';
  import { clickoutside } from '@Foundation/directives/clickoutside/clickoutside';


  export default {
    name: 'SearchFiltersProductsSorting',
    directives: {
      clickoutside
    },
    props: {
      sortCtaMobileLabel: { type: String, required: false, default: 'Sort Mobile' },
      sortCtaDesktopLabel: { type: String, required: false, default: 'Sort Desktop' },
      sortExpandIconAlt: { type: String, required: false, default: 'Sort Expand Icon Alt' },
      sortCollapseIconAlt: { type: String, required: false, default: 'Sort Collapse Icon Alt' },
      eventCategory: { type: String, required: false, default: 'Search' }
    },
    data() {
      return {
        smallScreen: !window.matchMedia('(min-width: 1280px)').matches,
        displayingPopup: false
      };
    },
    computed: {
      ...mapGetters('searchFiltersStore', [
        'isLoadingFilters',
        'productsSorting',
        'selectedProductsSorting'
      ]),
      selectedOption: {
        get() {
          return this.selectedProductsSorting;
        },
        set(value) {
          this.selectProductsSortingOption(value);
          this.closePopup();
          this.sendTaggingEvent();
        }
      },
      selectedLabel() {
        return this.productsSorting.options.find(e => e.id === this.selectedProductsSorting).title;
      },
      taggingEvent() {
        return {
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: this.eventCategory,
          eventAction: 'sort',
          eventLabel: this.selectedLabel,
          event_name: 'use_filters',
          filter_type: 'sort',
          filter_value: `${this.eventCategory}::${this.selectedLabel}`,
        };
      }
    },
    methods: {
      ...mapActions('searchFiltersStore', [
        'selectProductsSortingOption',
      ]),
      togglePopup() {
        this.displayingPopup = !this.displayingPopup;
      },
      closePopup() {
        this.displayingPopup = false;
      },
      sendTaggingEvent() {
        AnalyticsHandler.pushDataLayer(this.taggingEvent);
      }
    }
  };
</script>
